<template>
  <div>
    <Drawer title="站点详情" width="900" :value="showEdit" :mask-closable="true" @on-close="cancelEdit">
      <Tabs type="card">
        <TabPane label="基础信息">
          <Row>
            <Col span="12" class="info-item">
              <span>油站ID:</span>
              <span>{{ baseInfo.station_id }}</span>
            </Col>
            <Col span="12" class="info-item">
              <span>类型:</span>
              <span>{{ baseInfo.self_support_name }}</span>
            </Col>
            <!--<Col span="12" class="info-item" >
              <span>推荐上级:</span>
              <span v-if="baseInfo.parent_info">{{baseInfo.parent_info.nick_name}} {{baseInfo.parent_info.mobile}}</span>
              <span v-else></span>
            </Col>-->
            <Col span="12" class="info-item">
              <span>合伙人:</span>
              <span v-if="baseInfo.agent_info">{{ baseInfo.agent_info.nick_name }} {{ baseInfo.agent_info.mobile }}</span>
              <span v-else></span>
            </Col>
            <Col span="12" class="info-item">
              <span>站点类型:</span>
              <span>{{ baseInfo.type_name }}</span>
            </Col>
            <Col span="12" class="info-item">
              <span>业务类型:</span>
              <span>
                <i-switch v-model="baseInfo.is_bill" size="large" true-color="#13ce66" false-color="#ff4949"
                  @on-change="setIsBill" :true-value="1" :false-value="-1">
                  <span slot="open">A型</span>
                  <span slot="close">B型</span>
                </i-switch>
              </span>
            </Col>
            <Col span="12" class="info-item">
              <span>是否可提现:</span>
              <span>{{ baseInfo.is_withdraw === 1 ? '可提现' : '不可提现' }}</span>
            </Col>
            <Col span="12" class="info-item">
              <span>经纬度:</span>
              <span>{{ baseInfo.longitude }}，{{ baseInfo.latitude }}</span>
            </Col>
            <Col span="24" class="info-item">
              <span>地址:</span>
              <span>{{ baseInfo.gas_address }}
                <Button size="small" type="primary" @click="showAddressModal">修改</Button>
                <Button style="margin-left: 15px" size="small" type="primary" @click="toMapPicker">坐标拾取器</Button>
              </span>
            </Col>
            <Col span="12" class="info-item">
              <span>站点名称:</span>
              <span>{{ baseInfo.gas_name }}</span>
            </Col>

            <Col span="12" class="info-item">
              <span>省市区:</span>
              <span>{{ baseInfo.province_name }}/{{ baseInfo.city_name }}/{{ baseInfo.county_name }} </span>
            </Col>
            <Col span="12" class="info-item" v-if="baseInfo.station_type === 'oil_station'">
              <span>油品来源:</span>
              <span>{{ baseInfo.private_gas_source }}</span>
            </Col>
            <Col span="12" class="info-item">
              <span>营业时间:</span>
              <span>{{ baseInfo.work_start_time }} - {{ baseInfo.work_end_time }}</span>
            </Col>
            <Col span="12" class="info-item">
              <span>联系人:</span>
              <span>{{ baseInfo.contact_user }}</span>
            </Col>
            <Col span="12" class="info-item">
              <span>联系电话:</span>
              <span>{{ baseInfo.contact_mobile ? baseInfo.contact_mobile[0] : '' }}</span>
            </Col>
            <Col span="12" class="info-item">
              <span>联系电话2:</span>
              <span>{{ baseInfo.contact_mobile ? baseInfo.contact_mobile[1] : '' }}</span>
            </Col>
            <Col span="12" class="info-item">
              <span>注册时间:</span>
              <span>{{ baseInfo.create_time }}</span>
            </Col>
            <Col span="12" class="info-item">
              <span>油机价:</span>
              <span>{{ baseInfo.station_price }}</span>
            </Col>
            <Col span="12" class="info-item">
              <span>挂牌价:</span>
              <span>{{ baseInfo.ndrc_price }}</span>
            </Col>
            <Col span="12" class="info-item">
              <span>状态:</span>
              <span>
                {{ baseInfo.gas_status_name }}

                <!-- 支持三种状态：1=正常, -1=禁用, 3=重复站已禁用；当为 5（待审核）时保留审核操作 -->
                <template v-if="baseInfo.gas_status !== 5">
                  <Select v-model="gas_status" style="width:180px" @on-change="changeStatus">
                    <Option value="1">正常</Option>
                    <Option value="-1">禁用</Option>
                    <Option value="3">重复站已禁用</Option>
                  </Select>
                </template>
                <template v-else-if="baseInfo.gas_status === 5">
                  <Button size="small" type="primary" @click="verify('pass')">审核通过</Button>
                  <Button size="small" type="error" @click="verify('deny')">审核不通过</Button>
                </template>
              </span>
            </Col>
            <Col span="12" class="info-item">
              <span>是否置顶:</span>
              <span>
                <i-switch v-model="baseInfo.is_top" @on-change="setIsTop" :true-value="1" :false-value="-1" />
              </span>
            </Col>

            <Col span="12" class="info-item">
              <span>开通库存:</span>
              <span>
                <i-switch v-model="baseInfo.is_open_stock" @on-change="setIsOpenStock" :true-value="1"
                  :false-value="-1" />
              </span>
            </Col>

            <Col span="12" class="info-item">
              <span>是否壳牌支付:</span>
              <span>
                <i-switch v-model="baseInfo.is_need_qppay" @on-change="setIsNeedQppay" :true-value="1"
                  :false-value="-1" />
              </span>
            </Col>

            <Col span="12" class="info-item">
              <span>是否需要核销:</span>
              <span>
                <i-switch v-model="baseInfo.verification_tag" @on-change="setVerificationTag" :true-value="1"
                  :false-value="0">
                  <span slot="open">需要</span>
                  <span slot="close">不需要</span>
                </i-switch>
              </span>
            </Col>


            <Col span="24" class="info-item" v-if="baseInfo.type === 1">
              <span style="line-height: 40px;vertical-align: bottom;">油站图片:</span>
              <span v-if="baseInfo.gas_logo_big">
                <viewer :images="[baseInfo.gas_logo_big]">
                  <img :key="baseInfo.gas_logo_big" :src="baseInfo.gas_logo_big"
                    style="width: 30px;height: 30px;margin: 5px">
                </viewer>
              </span>
            <span v-else>暂无图片</span>
            </Col>



          </Row>

          <Row>
            <Col span="12" class="info-item">
            <span>加油抽成:</span>
            <span>
              <Input v-model="baseInfo.commission_litre" style="display:inline-table;width: 50%;margin-right: 5px">
              <template #append>
                <span>/L</span>
              </template>
              </Input>
              <Button type="primary" size="small" @click="setCommissionLitre">修改</Button>
            </span>
            </Col>
            <Col span="12" class="info-item">
              <span>业务员:</span>
              <span>
                <Input v-model="baseInfo.salesman" style="display:inline-table;width: 50%;margin-right: 5px"></Input>
                <Button type="primary" size="small" @click="editSalesman">修改</Button>
              </span>
            </Col>
            <!--<Col span="12" class="info-item">
              <span>电话抽成:</span>
              <span>
                <Input v-model="baseInfo.commission_mobile" style="width: 30%;margin-right: 5px"></Input>
                <Button type="primary" size="small" @click="setCommissionMobile">修改</Button>
              </span>
            </Col>-->
            <!--<Col span="12" class="info-item">
              <span>发票价格:</span>
              <span>
                <Input v-model="baseInfo.bill_price" style="width: 30%;margin-right: 5px"></Input>
                <Button type="primary" size="small" @click="setBillPrice">修改</Button>
              </span>
            </Col>-->
            <Col span="12" class="info-item">
              <span>发票价格:</span>
              <span>
                <span>{{ baseInfo.bill_price || 0 }}</span>
              </span>
            </Col>
            <Col span="12" class="info-item">
              <span>对外价格:</span>
              <span>
                <span>{{ baseInfo.price || 0 }}</span>
              </span>
            </Col>
            <Col span="12" class="info-item">
              <span>成本A:</span>
              <span>
                <span>{{ baseInfo.price2 || 0 }}</span>
              </span>
            </Col>
            <Col span="12" class="info-item">
              <span>成本B:</span>
              <span>
                <span>{{ baseInfo.no_bill_price || 0 }}</span>
                <Button type="primary" size="small" @click="editPriceForm.isShow = true"
                  style="margin-left: 10px">价格修改</Button>
              </span>
            </Col>
            <Col span="12" class="info-item">
              <span>现金收款:</span>
              <span>
                <i-switch size="large" v-if="baseInfo" v-model="baseInfo.is_cash" @on-change="setIsCash" :true-value="1"
                  :false-value="-1">
                  <span slot="open">正常</span>
                  <span slot="close">禁用</span>
                </i-switch>
              </span>
            </Col>
            <Col span="24">
              <p>收款二维码:</p>
              <p style="display: flex;align-items: center;">
                <Upload :action="apiPath + '/admin/common/uploadSettleImg'" :on-success="uploadSuccess"
                  :on-error="uploadError" :on-remove="handleRemove" :on-preview="seeImg" :before-upload="beforeUpload"
                  :format="['jpg', 'jpeg', 'png']" :max-size="2048" :on-format-error="formatError"
                  :on-exceeded-size="exceededSize" :default-file-list="payment_qrcode">
                  <Button icon="ios-cloud-upload-outline" type="primary">点击上传</Button>
                </Upload>
                <Button style="margin-left: 150px" type="primary" @click="savePaymentQrcode">确定</Button>
              </p>
            </Col>
          </Row>
          <Row>
            <Col span="24" style="display: flex;align-items: center;margin-top: 10px">
            <span>现场收款展示车队:</span>
            <span style="display: flex;flex: 1">
              <Select v-model="collection_companys" placeholder="请选择车队" multiple transfer style="flex: 1">
                <Option v-for="item in baseInfo.collection_companys" :key="item.company_id" :value="item.company_id"
                  :selected="item.checked">
                  {{ item.company_name }}
                </Option>
              </Select>
              <Button type="primary" size="small" @click="setCollectionCompanys">修改</Button>
            </span>
            </Col>
          </Row>
        </TabPane>
        <TabPane label="修改">
          <Form ref="editForm" :label-width="100" :model="editFormData">
            <FormItem label="站点名称" prop="gas_name">
              <Input v-model="editFormData.gas_name" placeholder=""></Input>
            </FormItem>
            <Row>
              <Col span="8">
              <FormItem label="站点类型" prop="station_type">
                <Select v-model="editFormData.station_type" placeholder="站点类型">
                  <Option value="">全部站点</Option>
                  <Option v-for="(item, key) in station_types" :key="key" :value="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="油站类型" prop="oil_station_type">
                <Select v-model="editFormData.oil_station_type" placeholder="油站类型">
                  <Option value="2">油车</Option>
                  <Option value="3">撬装</Option>
                  <Option value="4">加油站</Option>
                </Select>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="渠道" prop="platform">
                <Select v-model="editFormData.platform" placeholder="渠道">
                  <Option v-for="(item, key) in platform" :key="key" :value="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
              </Col>

            </Row>

            <Row>
              <Col span="8">
              <FormItem label="是否高速" prop="highspeed">
                <Select v-model="editFormData.highspeed">
                  <Option value="">是否高速</Option>
                  <Option value="1">是</Option>
                  <Option value="-1">否</Option>
                </Select>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="品牌" prop="brand">
                <Select v-model="editFormData.brand">
                  <Option value="">请选择</Option>
                  <Option v-for="(item, key) in brands" :key="key" :value="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="8">
              <FormItem label="联系人" prop="contact_user">
                <Input v-model="editFormData.contact_user" placeholder=""></Input>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="联系电话1" prop="contact_mobile">
                <Input v-model="editFormData.contact_mobile" placeholder=""></Input>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="联系电话2" prop="contact_mobile2">
                <Input v-model="editFormData.contact_mobile2" placeholder=""></Input>
              </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
              <FormItem label="业务员" prop="salesman">
                <Input v-model="editFormData.salesman" placeholder=""></Input>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="营业开始时间" prop="work_start_time">
                <Input v-model="editFormData.work_start_time" placeholder=""></Input>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="营业结束时间" prop="work_end_time">
                <Input v-model="editFormData.work_end_time" placeholder=""></Input>
              </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="8">
              <FormItem label="挂牌价" prop="ndrc_price">
                <Input type="number" v-model="editFormData.ndrc_price" placeholder=""></Input>
              </FormItem>
              </Col>
              <Col span="8">
              <FormItem label="油机价" prop="station_price">
                <Input type="number" v-model="editFormData.station_price" placeholder=""></Input>
              </FormItem>
              </Col>
            </Row>

            <FormItem>
              <Button type="primary" @click="editStationData">确定</Button>
            </FormItem>
          </Form>
        </TabPane>
      </Tabs>
      <Tabs>
        <TabPane label="订单列表">
          <pageTable ref="orderTable" :tableTitle="orderTableColumn" :searchData="{}" :tableHeight="300"
            :showSearchForm="false" :defaultSearchParam="{ station_id: this.station_id }"
            tableApi="admin/order/getStationOrders">
          </pageTable>
        </TabPane>
        <TabPane label="店员列表">
          <pageTable ref="stationUserTable" :tableTitle="stationUserColumn" :searchData="{}" :tableHeight="300"
            :showSearchForm="false" :defaultSearchParam="{ station_id: this.station_id }"
            tableApi="admin/gas/getStationUser">
            <template v-slot:otherBtn>
              <FormItem>
                <Button type="primary" @click="addStationUserModel.isShow = true">添加</Button>
              </FormItem>
            </template>
          </pageTable>
        </TabPane>
      </Tabs>
      <Modal v-model="addressModal.isShow" :title="addressModal.title" :loading="addressModal.isLoading"
        @on-ok="editAddress" @on-cancel="cancelAddressModal">
        <Form ref="addressForm" :label-width="100" :model="addressForm">
          <FormItem label="省" prop="province_name">
            <Input v-model="addressForm.province_name" placeholder=""></Input>
          </FormItem>
          <FormItem label="市" prop="city_name">
            <Input v-model="addressForm.city_name" placeholder=""></Input>
          </FormItem>
          <FormItem label="区" prop="county_name">
            <Input v-model="addressForm.county_name" placeholder=""></Input>
          </FormItem>
          <FormItem label="精度,如104.07275" prop="longitude">
            <Input v-model="addressForm.longitude" placeholder=""></Input>
          </FormItem>
          <FormItem label="维度,如30.57899" prop="latitude">
            <Input v-model="addressForm.latitude" placeholder=""></Input>
          </FormItem>
          <FormItem label="地址" prop="gas_address">
            <Input v-model="addressForm.gas_address" placeholder=""></Input>
          </FormItem>
        </Form>
      </Modal>
      <Modal v-model="addStationUserModel.isShow" title="添加站点员工" @on-ok="addStationUser"
        @on-cancel="addStationUserModel.isShow = false">
        <Form ref="stationUserForm" :label-width="100" :model="addStationUserModel">
          <FormItem label="姓名" prop="name">
            <Input v-model="addStationUserModel.name" placeholder=""></Input>
          </FormItem>
          <FormItem label="手机号" prop="mobile">
            <Input v-model="addStationUserModel.mobile" placeholder=""></Input>
          </FormItem>
        </Form>
      </Modal>
      <Modal v-model="editPriceForm.isShow" :title="`${baseInfo.gas_name} 修改价格`" @on-ok="editPrice"
        @on-cancel="editPriceForm.isShow = false">
        <Form ref="editPriceForm" :label-width="100" :model="editPriceForm">
          <FormItem label="对外价格" prop="price">
            <Input v-model="editPriceForm.price" placeholder=""></Input>
          </FormItem>
          <FormItem label="成本A" prop="price2">
            <Input v-model="editPriceForm.price2" :disabled="isBillBType" placeholder=""></Input>
          </FormItem>
          <FormItem label="成本B" prop="no_bill_price">
            <Input v-model="editPriceForm.no_bill_price" :disabled="isBillAType" placeholder=""></Input>
          </FormItem>
          <FormItem label="挂牌价" prop="ndrc_price">
            <Input v-model="editPriceForm.ndrc_price" placeholder=""></Input>
          </FormItem>
          <FormItem label="调价时间" prop="fixed_time">
            <DatePicker type="datetime" v-model="editPriceForm.fixed_time" style="width: 200px"></DatePicker>
          </FormItem>
          <div v-if="scheduledChange && scheduledChange.fixed_time" style="margin-top:8px;padding:8px;border:1px dashed #e8e8e8;border-radius:4px;background:#fafafa">
            <p style="margin:0 6px 6px;color:#666;font-size:12px">已预约尚未执行的调价记录：<span style="color:#333;font-weight:500">{{ scheduledChange.fixed_time }}</span></p>
            <table style="width:100%;border-collapse:collapse;font-size:13px;color:#333">
              <tbody>
                <tr v-if="scheduledChange.new_price">
                  <td style="padding:4px 8px;border-top:1px solid #eee;width:36%;color:#666">对外价格</td>
                  <td style="padding:4px 8px;border-top:1px solid #eee">由 {{ scheduledChange.old_price }} 修改为 {{ scheduledChange.new_price }}</td>
                </tr>
                <tr v-if="scheduledChange.new_price2">
                  <td style="padding:4px 8px;border-top:1px solid #eee;color:#666">成本A</td>
                  <td style="padding:4px 8px;border-top:1px solid #eee">由 {{ scheduledChange.old_price2 }} 修改为 {{ scheduledChange.new_price2 }}</td>
                </tr>
                <tr v-if="scheduledChange.new_no_bill_price">
                  <td style="padding:4px 8px;border-top:1px solid #eee;color:#666">成本B</td>
                  <td style="padding:4px 8px;border-top:1px solid #eee">由 {{ scheduledChange.old_no_bill_price }} 修改为 {{ scheduledChange.new_no_bill_price }}</td>
                </tr>
                <tr v-if="scheduledChange.new_ndrc_price">
                  <td style="padding:4px 8px;border-top:1px solid #eee;color:#666">挂牌价</td>
                  <td style="padding:4px 8px;border-top:1px solid #eee">由 {{ scheduledChange.old_ndrc_price }} 修改为 {{ scheduledChange.new_ndrc_price }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Form>
      </Modal>

    </Drawer>
  </div>
</template>

<script>
import pageTable from "@/components/table/pageTable";
import config from '@/config/base-config'
export default {
  name: "edit",
  components: { pageTable },
  props: {
    showEdit: {
      type: Boolean,
      default: false
    },
    station_id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      apiPath: config.API_PATH,
      // 初始化 baseInfo 并保证开关字段有合法数值，避免渲染时 watcher 报错
      baseInfo: {
        is_cash: -1,
        is_top: -1,
        is_open_stock: -1,
        is_need_qppay: -1,
        is_bill: -1,
        gas_status: 1,
        verification_tag: 0
      },
      gas_status: '1',
      orderTableColumn: [
        { title: 'ID', key: 'order_id', align: 'center' },
        { title: '司机', key: 'mobile', align: 'center' },
        { title: '车队', key: 'company_name', align: 'center' },
        { title: '订单类型', key: 'oil_station_type_name', align: 'center' },
        { title: '总金额', key: 'total_price', align: 'center' },
        { title: '数量(升)', key: 'litre_num', align: 'center' },
        { title: '单价', key: 'buy_price', align: 'center' },
        { title: '应收金额', key: 'supplier_income', align: 'center' },
        { title: '下单时间', key: 'create_time', align: 'center', width: 140 },
      ],
      commissionTableColumn: [
        { title: '资金来源', key: 'record_type_name', align: 'center' },
        { title: '金额', key: 'amount', align: 'center' },
        { title: '消费前数量', key: 'before_amount', align: 'center' },
        { title: '消费后数量', key: 'after_amount', align: 'center' },
        { title: '发生时间', key: 'create_time', align: 'center' },
      ],
      //店员列表
      stationUserColumn: [
        { title: 'UID', key: 'user_id', align: 'center' },
        { title: '姓名', key: 'name', align: 'center' },
        { title: '手机号', key: 'mobile', align: 'center' },
        { title: '注册时间', key: 'oil_station_type_name', align: 'center' },
        {
          title: '操作', align: 'center', render: (h, params) => {
            return h('Button', {
              props: { size: 'small', type: 'error' },
              on: {
                click: () => {
                  this.deleteStationUser(params.row.id)
                }
              }
            }, '删除')
          }
        },
      ],
      collection_companys: [],
      payment_qrcode: [],
      addressModal: {
        isShow: false,
        title: '地址修改',
        isLoading: false
      },
      addressForm: {
        station_id: 0,
        province_name: '',
        city_name: '',
        county_name: '',
        longitude: '',
        latitude: '',
        gas_address: '',
      },
      addStationUserModel: {
        isShow: false,
        isLoading: false,
        name: '',
        mobile: '',
      },
      editPriceForm: {
        isShow: false,
        price: '',
        price2: '',
        no_bill_price: '',
        fixed_time: '',
        ndrc_price: '',
      },
      // 已预约但尚未执行的调价记录
      scheduledChange: null,
      isSyncingPrice: false,
      ticketPointConfig: {
        ticket_point_oil: 0,
        ticket_point_lng: 0,
        ticket_point_oil_b: 0,
        ticket_point_lng_b: 0,
      },
      ticketPointLoaded: false,
      editFormData: {
        gas_name: '',
        station_type: '',
        oil_station_type: '',
        contact_user: '',
        contact_mobile: '',
        contact_mobile2: '',
        platform: '',
        salesman: '',
        work_start_time: '',
        work_end_time: '',
        station_price: '',
        ndrc_price: '',
        highspeed: '',
        brand: ''
      },
      station_types: [],
      platform: [],
      brands: [],
    }
  },
  computed: {
    isBillAType() {
      return Number(this.baseInfo.is_bill) === 1
    },
    isBillBType() {
      return !this.isBillAType
    }
  },
  watch: {
    async 'editPriceForm.isShow'(val) {
      if (val) {
        await this.fetchTicketPointConfig()
        this.syncPriceByBillType()
      }
    },
    'editPriceForm.price2'(val) {
      if (!this.editPriceForm.isShow || !this.isBillAType || this.isSyncingPrice) return
      this.syncPriceByBillType('price2', val)
    },
    'editPriceForm.no_bill_price'(val) {
      if (!this.editPriceForm.isShow || !this.isBillBType || this.isSyncingPrice) return
      this.syncPriceByBillType('no_bill_price', val)
    }
  },
  methods: {
    async fetchTicketPointConfig(force = false) {
      if (this.ticketPointLoaded && !force) return
      let res = await this.$commonFun.postProxy('admin/gas/getTicketPoint', {})
      this.$commonFun.dealApiResult(res, () => {
        this.ticketPointConfig.ticket_point_oil = Number(res.data.ticket_point_oil || 0)
        this.ticketPointConfig.ticket_point_lng = Number(res.data.ticket_point_lng || 0)
        this.ticketPointConfig.ticket_point_oil_b = Number(res.data.ticket_point_oil_b || 0)
        this.ticketPointConfig.ticket_point_lng_b = Number(res.data.ticket_point_lng_b || 0)
        this.ticketPointLoaded = true
      })
    },
    getTicketPoint() {
      const isBillAType = Number(this.baseInfo.is_bill) === 1
      const isLngStation = this.baseInfo.station_type === 'lng_station'
      let point = 0

      if (isLngStation) {
        point = isBillAType ? this.ticketPointConfig.ticket_point_lng : this.ticketPointConfig.ticket_point_lng_b
      } else {
        point = isBillAType ? this.ticketPointConfig.ticket_point_oil : this.ticketPointConfig.ticket_point_oil_b
      }

      if ((!Number.isFinite(Number(point)) || Number(point) <= 0) && this.baseInfo.piaodian !== undefined) {
        point = Number(this.baseInfo.piaodian)
      }
      return Number.isFinite(point) && point >= 0 ? point : 0
    },
    parsePriceValue(val) {
      if (val === '' || val === null || val === undefined) return null
      const num = Number(val)
      return Number.isFinite(num) ? num : null
    },
    syncPriceByBillType(sourceField = '') {
      const ticketPoint = this.getTicketPoint()
      this.isSyncingPrice = true

      if (this.isBillAType) {
        const price2 = this.parsePriceValue(this.editPriceForm.price2)
        this.editPriceForm.no_bill_price = price2 === null ? '' : (price2 - ticketPoint).toFixed(2)
      } else {
        const noBillPrice = this.parsePriceValue(this.editPriceForm.no_bill_price)
        this.editPriceForm.price2 = noBillPrice === null ? '' : (noBillPrice + ticketPoint).toFixed(2)
      }

      this.$nextTick(() => {
        this.isSyncingPrice = false
      })
    },
    async initPage() {
      let data = await this.$commonFun.postProxy('admin/common/getPageInitInfo', { type: ['stationType', 'platform', 'brand'] })
      this.station_types = data.data.stationType;
      this.platform = data.data.platform;
      this.brands = data.data.brand;
    },
    async getInfo() {
      let res = await this.$commonFun.postProxy('admin/gas/getDetailInfo', { station_id: this.station_id });
      this.$commonFun.dealApiResult(res, () => {
        // 先在本地处理并转换类型，保证赋值到 this.baseInfo 时所有开关字段已经是合法的 true/false 值（1 / -1）
        const data = Object.assign({}, res.data);
        data.is_cash = Number(res.data.is_cash || -1);
        data.is_top = Number(res.data.is_top || -1);
        data.is_open_stock = Number(res.data.is_open_stock || -1);
        data.is_need_qppay = Number(res.data.is_need_qppay || -1);
        data.is_bill = (res.data.is_bill === undefined || res.data.is_bill === null) ? -1 : Number(res.data.is_bill);
        data.gas_status = Number(res.data.gas_status || 1);
        data.verification_tag = Number(res.data.verification_tag || -1);
        // 最后一次性赋值，避免中间状态触发 i-switch 的 watcher 警告
        this.baseInfo = data;
        this.gas_status = String(data.gas_status);
        if (res.data.payment_qrcode) {
          this.payment_qrcode = [{ name: '支付二维码', url: res.data.payment_qrcode }]
        }
        this.editPriceForm.price = res.data.price;
        this.editPriceForm.price2 = res.data.price2;
        this.editPriceForm.no_bill_price = res.data.no_bill_price;
        this.editPriceForm.ndrc_price = res.data.ndrc_price;
        this.editPriceForm.fixed_time = res.data.fixed_time || '';
        // 如果存在固定调价时间且为将来时间，展示已预约的调价记录
        if (res.data.fixed_time) {
          // 兼容 Date 构造（替换 '-' 为 '/'）
          const scheduledDate = new Date(res.data.fixed_time.replace(/-/g, '/'));
          if (!isNaN(scheduledDate.getTime()) && scheduledDate.getTime() > Date.now()) {
            this.scheduledChange = {
              fixed_time: res.data.fixed_time,
              // 新值（预约要变更到的值）
              new_price: res.data.new_price,
              new_price2: res.data.new_price2,
              new_no_bill_price: res.data.new_no_bill_price,
              new_ndrc_price: res.data.new_ndrc_price,
              // 旧值（当前生效的值）
              old_price: res.data.price,
              old_price2: res.data.price2,
              old_no_bill_price: res.data.no_bill_price,
              old_ndrc_price: res.data.ndrc_price
            }
          } else {
            this.scheduledChange = null
          }
        } else {
          this.scheduledChange = null
        }
        this.collection_companys = res.data.selected_collection_companys;
        this.editFormData.gas_name = res.data.gas_name;
        this.editFormData.station_type = res.data.station_type;
        this.editFormData.oil_station_type = res.data.type + '';
        this.editFormData.contact_user = res.data.contact_user;
        this.editFormData.contact_mobile = res.data.contact_mobile[0] ? res.data.contact_mobile[0] : '';
        this.editFormData.contact_mobile2 = res.data.contact_mobile[1] ? res.data.contact_mobile[1] : '';
        this.editFormData.platform = res.data.platform;
        this.editFormData.salesman = res.data.salesman;
        this.editFormData.work_start_time = res.data.work_start_time;
        this.editFormData.work_end_time = res.data.work_end_time;
        this.editFormData.station_price = res.data.station_price;
        this.editFormData.ndrc_price = res.data.ndrc_price;
        this.editFormData.highspeed = res.data.highspeed == 1 ? '1' : '-1';
        this.editFormData.brand = res.data.brand;
      })
    },
    cancelEdit() {
      this.$emit('cancel-edit')
    },
    changeStatus(status) {
      // 确保传给后端为数字
      const newStatus = Number(status)
      this.$commonFun.postProxy('admin/gas/changeStatus', { station_id: this.station_id, status: newStatus }).then(res => {
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        })
      })
    },
    savePaymentQrcode() {
      if (!this.payment_qrcode[0]) {
        return this.$commonFun.errorTip('请先上传')
      }
      this.$commonFun.postProxy('admin/gas/savePaymentQrcode', { station_id: this.station_id, payment_qrcode: this.payment_qrcode[0].url }).then(res => {
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        })
      })
    },
    verify(status) {
      this.$commonFun.postProxy('admin/gas/verify', { station_id: this.station_id, status }).then(res => {
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        })
      })
    },
    setCommissionLitre() {
      this.$commonFun.postProxy('admin/gas/setCommissionLitre', { station_id: this.station_id, commission: this.baseInfo.commission_litre }).then(res => {
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        })
      })
    },
    setCommissionMobile() {
      this.$commonFun.postProxy('admin/gas/setCommissionMobile', { station_id: this.station_id, commission: this.baseInfo.commission_mobile }).then(res => {
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        })
      })
    },
    setBillPrice() {
      this.$commonFun.postProxy('admin/gas/setBillPrice', { station_id: this.station_id, bill_price: this.baseInfo.bill_price }).then(res => {
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        })
      })
    },
    setPrice() {
      this.$commonFun.postProxy('admin/gas/setStationPrice', { station_id: this.station_id, price: this.baseInfo.price }).then(res => {
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        })
      })
    },
    setPrice2() {
      this.$commonFun.postProxy('admin/gas/setStationPrice2', { station_id: this.station_id, price: this.baseInfo.price2 }).then(res => {
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        })
      })
    },
    setNoBillPrice() {
      this.$commonFun.postProxy('admin/gas/setNoBillPrice', { station_id: this.station_id, price: this.baseInfo.no_bill_price }).then(res => {
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        })
      })
    },
    async setIsOpenStock() {
      this.$commonFun.postProxy('admin/gas/setOpenStock', { station_id: this.station_id, isOpen: this.baseInfo.is_open_stock }).then(res => {
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        })
      })
    },
    async setIsNeedQppay() {
      this.$commonFun.postProxy('admin/gas/setIsNeedQppay', { station_id: this.station_id, is_need_qppay: this.baseInfo.is_need_qppay }).then(res => {
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        })
      })
    },
    async setVerificationTag() {
      this.$commonFun.postProxy('admin/gas/setVerificationTag', { station_id: this.station_id, verification_tag: this.baseInfo.verification_tag }).then(res => {
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        })
      })
    },
    async setIsBill() {
      let res = await this.$commonFun.postProxy('admin/gas/setIsBill', { station_id: this.station_id, is_bill: this.baseInfo.is_bill })
      this.$commonFun.dealApiResult(res, () => {
        this.$commonFun.successTip(res.msg, () => {
          this.getInfo();
        })
      })
    },
    setIsTop() {
      this.$commonFun.postProxy('admin/gas/setIsTop', { station_id: this.station_id, is_top: this.baseInfo.is_top }).then((res) => {
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        })
      })
    },
    setIsCash() {
      this.$commonFun.postProxy('admin/gas/setIsCash', { station_id: this.station_id, is_cash: this.baseInfo.is_cash }).then((res) => {
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        })
      })
    },
    setCollectionCompanys() {
      this.$commonFun.postProxy('admin/gas/setCollectionCompanys', { station_id: this.station_id, collection_companys: this.collection_companys }).then((res) => {
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg, () => {
            this.getInfo();
          })
        })
      })
    },
    async addStationUser() {
      this.addStationUserModel.isLoading = true
      let res = await this.$commonFun.postProxy('admin/gas/addStationUser', { station_id: this.station_id, name: this.addStationUserModel.name, mobile: this.addStationUserModel.mobile })
      this.$commonFun.dealApiResult(res, () => {
        this.$commonFun.successTip(res.msg, () => {
          this.addStationUserModel.isLoading = false
          this.addStationUserModel.isShow = false
          this.$refs['stationUserTable'].changePage(1)
        })
      })
    },
    async deleteStationUser(id) {
      let res = await this.$commonFun.postProxy('admin/gas/delStationUser', { station_id: this.station_id, id })
      this.$commonFun.dealApiResult(res, () => {
        this.$commonFun.successTip(res.msg, () => {
          this.$refs['stationUserTable'].changePage(1)
        })
      })
    },
    async editSalesman() {
      let res = await this.$commonFun.postProxy('admin/gas/editSalesman', { station_id: this.station_id, salesman: this.baseInfo.salesman })
      this.$commonFun.dealApiResult(res)
    },
    uploadSuccess(res, file) {
      file.url = res.data.url;
      file.name = res.data.url;
      this.payment_qrcode = [{ name: "支付二维码", url: res.data.url }]
    },
    handleRemove() {
      // const fileList = this.$refs.upload.fileList;
      /*this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
      this.proofs.splice(fileList.indexOf(file), 1)*/
      this.payment_qrcode = []
    },
    uploadError() {
      this.$commonFun.errorTip('上传失败请重试')
    },
    formatError() {
      this.$commonFun.errorTip('图片格式不正确 jpg、jpeg、png')
    },
    exceededSize() {
      this.$commonFun.errorTip('图片大小不能超过2M')
    },
    beforeUpload() {
      if (this.payment_qrcode.length >= 2) {
        this.$commonFun.errorTip('最多只能上传3张图片')
        return false;
      }
    },
    seeImg(file) {
      this.$Modal.info({
        // title: title,
        width: 800,
        footerHide: true,
        content: `<img src="${file.url}" style="max-width: 500px;max-height: 500px">`
      });
    },
    async editAddress() {
      this.addressModal.isLoading = true
      this.addressForm.station_id = this.station_id
      let res = await this.$commonFun.postProxy('admin/gas/editAddress', this.addressForm);
      this.$commonFun.dealApiResult(res, () => {
        this.$commonFun.successTip(res.msg, () => {
          this.getInfo()
          this.addressModal.isShow = false
          this.addressModal.isLoading = false
        })
      })
    },
    showAddressModal() {
      this.addressModal.isShow = true
    },
    cancelAddressModal() {
      this.addressModal.isShow = false
      this.addressModal.isLoading = false
    },
    toMapPicker() {
      window.open('https://lbs.amap.com/tools/picker')
    },
    async editPrice() {
      let params = this.editPriceForm;
      params['station_id'] = this.station_id;
      let res = await this.$commonFun.postProxy('admin/gas/editStationPrice', params);
      this.$commonFun.dealApiResult(res, () => {
        this.$commonFun.successTip(res.msg, () => {
          this.getInfo()
          this.editPriceForm.isShow = false
        })
      })
    },
    async editStationData() {
      let params = this.editFormData;
      params['station_id'] = this.station_id;
      let res = await this.$commonFun.postProxy('admin/gas/editStationData', params);
      this.$commonFun.dealApiResult(res, () => {
        this.$commonFun.successTip(res.msg, () => {
          this.getInfo()
        })
      })
    }
  },
  mounted() {
    this.initPage()
    this.fetchTicketPointConfig()
    this.getInfo()
  },
}
</script>

<style scoped lang="less">
.drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
